/* Polsk katalog for locale-settings-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'set.acc.assetAutomaticPostingExplanation': 'Amortyzacja jest księgowana automatycznie za każdy zakończony miesiąc. Plumme nadrabia brakujące miesiące bez Twojego udziału.',
  'set.acc.paymentDays': 'Domyślny termin płatności (dni)',
  'set.acc.paymentDaysHelp': 'Termin płatności wynika z daty faktury i tego terminu. Możesz go zmienić na każdej fakturze.',
  'set.acc.paymentDaysInvalid': 'Wybierz termin płatności od 0 do 365 pełnych dni.',
  'set.acc.foreignCurrencyInvoices': 'Faktury w walucie obcej',
  'set.acc.foreignCurrencyInvoicesHelp': 'Pokazuje walutę dokumentu i pola kursu w sekcji Nowa sprzedaż. Pozostaw wyłączone, jeśli fakturujesz tylko w walucie księgowej.',
  'set.acc.advancedVatDeduction': 'Zaawansowane odliczenie VAT w pozycjach zakupu',
  'set.acc.advancedVatDeductionHelp': 'Pokazuje opcje pełnego lub częściowego odliczenia, gdy dokument zawiera VAT. Wartość domyślna to 100 %, a istniejące odstępstwa są zawsze wyświetlane.',
  'set.acc.openingAssets': 'Środki trwałe w bilansie otwarcia',
  'set.acc.openingAssetsHelp': 'Zarejestruj szczegóły aktywów, które są już ujęte w bilansie otwarcia. Kwoty są uzgadniane z bilansem otwarcia, ale aktywa są prowadzone w ewidencji środków trwałych.',
  'set.acc.openingAssetsAction': 'Zarejestruj istniejący środek trwały',
  'set.acc.assetAutomation': 'Automatyczne miesięczne księgowanie amortyzacji',
  'set.acc.assetAutomationHelp': 'Sprawdź kwotę i okres przed potwierdzeniem. Aktywacja księguje zaległe zakończone miesiące i zatwierdza dalszą automatyzację. Wstrzymanie nie usuwa zaksięgowanych dokumentów.',
  'set.acc.assetAutomationActive': 'Aktywne dla wybranego roku obrotowego.',
  'set.acc.assetAutomationOff': 'Wyłączone dla wybranego roku obrotowego.',
  'set.acc.assetAutomationReview': 'Wstrzymane. Sprawdź i zatwierdź zaktualizowaną podstawę środków trwałych przed dalszym automatycznym księgowaniem.',
  'set.acc.assetAutomationEnableNote': 'Zatwierdzono automatyczne miesięczne księgowanie amortyzacji bilansowej.',
  'set.acc.assetAutomationDisableNote': 'Automatyczne miesięczne księgowanie zostało zatrzymane przez użytkownika.',
  'set.bank.activeFromHelp': 'Działania następcze oczekują wyciągów bankowych dopiero od tej daty.',
  'set.bank.noReconciliationHelp': 'Bez uzgodnienia bankowego musisz sam sprawdzać, czy wszystkie operacje bankowe są zaksięgowane dokładnie raz, czy saldo bankowe zgadza się z księgowością oraz czy płatności prywatne i firmowe nie są mieszane.',
  'set.bank.newAccount': 'Nowy rachunek bankowy',
  'set.bank.invoiceDeleteBlocked': 'Rachunku do faktur nie można usunąć, dopóki nie wybierzesz innego rachunku',
  'set.bank.deleteOrDisable': 'Usuń lub dezaktywuj rachunek',
  'set.bank.openingBalanceHelp': 'Saldo bankowe na koniec ostatniego już uzgodnionego dnia. Stanowi punkt kontrolny uzgodnienia bankowego, ale nie księguje bilansu otwarcia; BO wprowadza się w sekcji Księgowość z kontem przeciwstawnym.',
  'set.bank.openingBalanceDateHelp': 'Plumme rozpoczyna uzgodnienie bankowe dzień po tej dacie.',
  'set.bank.setupValidation.date': "Wybierz prawidłową datę.",
  'set.bank.setupValidation.year': "Data musi należeć do roku obrotowego {year}. Zmień rok obrotowy, aby ustawić inny początek.",
  'set.bank.setupValidation.amount': "Wpisz udokumentowane saldo bankowe. Wpisz 0, jeśli konto było puste.",
  'set.bank.setupValidation.counter': "Wybierz konto przeciwstawne z udokumentowanego bilansu otwarcia.",
  'set.bank.setupTitle': 'Ustaw saldo początkowe',
  'set.bank.setupIntro': 'Zarejestruj udokumentowane saldo bankowe i zbilansowane księgowanie w jednym procesie. Plumme nigdy nie zgaduje konta przeciwstawnego.',
  'set.bank.setupYearStart': 'Start z nowym rokiem obrotowym',
  'set.bank.setupYearStartHelp': 'Użyj salda na koniec poprzedniego roku jako BO banku w nowym roku.',
  'set.bank.setupMidYear': 'Przejście do Plumme w trakcie roku',
  'set.bank.setupMidYearHelp': 'Użyj salda z dnia poprzedzającego przejęcie księgowości przez Plumme.',
  'set.bank.setupNewAccount': 'Nowy rachunek bankowy w bieżącej księgowości',
  'set.bank.setupNewAccountHelp': 'Przelew na nowy rachunek to zwykła transakcja, a nie bilans otwarcia.',
  'set.bank.setupUnsupported': 'Łączne saldo początkowe banku i księgowości jest obecnie obsługiwane tylko dla norweskich rachunków w NOK. Dla tego rachunku użyj osobnych procesów księgowego i bankowego.',
  'set.bank.setupNewAccountTitle': 'Zaksięguj faktyczny przelew',
  'set.bank.setupNewAccountBody': 'Utwórz lub zaimportuj transakcję, która przeniosła pieniądze na rachunek. Gdy księga główna zgadza się z bankiem, uzgodnienie bankowe może się rozpocząć bez nowego bilansu otwarcia.',
  'set.bank.setupTransitionDate': 'Pierwszy dzień w Plumme',
  'set.bank.setupTransitionYearHint': "Pierwszy dzie\u0144 wybranego roku obrotowego. ({year})",
  'set.bank.setupTransitionMidYearHint': 'Data, od której Plumme przejmuje od poprzedniego systemu.',
  'set.bank.setupEvidenceDate': 'Saldo bankowe na dzień',
  'set.bank.setupEvidenceDateHint': 'Obliczane jako dzień przed przejęciem przez Plumme.',
  'set.bank.setupBankBalance': 'Udokumentowane saldo bankowe',
  'set.bank.setupBankBalanceHint': 'Użyj salda z wyciągu na dzień graniczny.',
  'set.bank.setupLedgerAccount': 'Konto bankowe w księdze głównej',
  'set.bank.setupCounterAccount': 'Konto przeciwstawne w bilansie otwarcia',
  'set.bank.setupCounterHelp': 'Wybierz, skąd pochodzi kwota bankowa. Nie da się tego ustalić na podstawie samego salda bankowego.',
  'set.bank.setupChooseCounter': 'Wybierz konto przeciwstawne',
  'set.bank.setupNoCounter': 'Przy saldzie zerowym konto przeciwstawne nie jest potrzebne',
  'set.bank.setupNoCounterMatches': 'Żadne konto bilansowe nie pasuje do wyszukiwania.',
  'set.bank.setupManagedInBank': 'Powiązane z saldem początkowym w Ustawienia - Bank',
  'set.bank.setupMidYearWarning': 'Saldo bankowe to tylko część przejścia. W sekcji Księgowość wprowadź lub zaimportuj też pozostałe dane bilansowe, wynikowe i VAT z poprzedniego systemu.',
  'set.bank.setupPreview': 'To zostanie zapisane łącznie',
  'set.bank.setupPreviewText': 'Dowód bankowy: {amount} na dzień graniczny. BO księgowy: {bank} w korespondencji z {counter}.',
  'set.bank.setupNotChosen': 'nie wybrano konta przeciwstawnego',
  'set.bank.setupSave': 'Zapisz saldo początkowe i BO',
  'set.bank.setupSaveError': 'Nie udało się zapisać salda początkowego.',
  'set.bank.setupPostingNote': 'Saldo początkowe banku – {account}',
  'set.bank.setupButton': 'Ustaw lub popraw saldo początkowe',
  'set.bank.setupSummaryTitle': 'Saldo bankowe na start',
  'set.bank.setupSummaryEmpty': 'Saldo początkowe i BO księgowy nie zostały ustawione.',
  'set.bank.setupSummaryValue': '{amount} na dzień {date}',
  'set.bank.setupSaved': 'Zapisano saldo początkowe i bilans otwarcia',
  'set.bank.setupSaveAccountFirst': 'Najpierw zapisz rachunek bankowy. Następnie można łącznie ustawić saldo początkowe i bilans otwarcia.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'Pokaż IBAN i BIC na fakturze',
  'set.role.owner': 'Właściciel',
  'set.access.noOrgNumber': 'Bez nr org.',
  'set.access.onboardingUnavailable': 'Onboarding nie został wczytany.',
  'set.access.members': 'Członkowie',
  'set.access.membersSub': 'Właściciel i administratorzy mogą usuwać aktywne dostępy. Własność musi zostać przeniesiona, zanim będzie można usunąć dostęp samego właściciela.',
  'set.access.membersOnlyAdmin': 'Tylko właściciel i administrator mogą zarządzać członkami.',
  'set.access.selfRemoveHelp': 'Nadal możesz usunąć własny dostęp, jeśli nie jesteś właścicielem.',
  'set.access.you': 'ty',
  'set.access.remove': 'Usuń',
  'set.access.membersEmpty': 'Aktywni członkowie są widoczni dla właściciela i administratora.',
  'set.access.removeSelf': 'Usuń mój dostęp',
  'set.access.transferTitle': 'Przenieś własność',
  'set.access.transferSub': 'Wyślij kontrolowane zaproszenie do nowego właściciela. Własność zostanie przeniesiona dopiero wtedy, gdy odbiorca się zaloguje i je przyjmie.',
  'set.access.transferOnlyOwner': 'Tylko właściciel może przenieść własność.',
  'set.access.transferAdminHelp': 'Administratorzy mogą zapraszać partnerów, ale nie mogą zmienić właściciela.',
  'set.access.newOwnerEmail': 'E-mail nowego właściciela',
  'set.access.afterTransferRole': 'Twój dostęp po przekazaniu',
  'set.access.roleAdministrator': 'Administrator',
  'set.access.transferReason': 'Powód / notatka do audytu',
  'set.access.transferReasonPlaceholder': 'Np. sprzedaż firmy lub utworzenie dla klienta',
  'set.access.sendTransfer': 'Wyślij zmianę właściciela',
  'set.access.ownershipTransfer': 'Zmiana właściciela',
  'set.access.expired': 'Wygasło',
  'set.access.viewAccept': 'Zobacz i zaakceptuj',
  'set.access.unknown': 'nieznany',
  'set.access.resend': 'Wyślij ponownie',
  'set.tab.accounting': 'Księgowość',
  'set.tab.data': 'Dane',
  'set.companyEmailHint': 'Pobierany z Twojego logowania.',
  'set.countryLocked': 'Kraj wybiera się przy tworzeniu firmy i nie można go tutaj zmienić. W razie błędu skontaktuj się z pomocą techniczną.',
  'set.inboxUpdatedAt': 'Ostatnia aktualizacja {date}',
  'set.inboxCopied': 'Skopiowano e-mail',
  'set.profileEmailHint': 'Adresu e-mail nie zmienia się tutaj, ponieważ Firebase może wymagać ponownego logowania.',
  'set.subscriptionPlan': 'Plan: {plan}',
  'set.subscriptionInactive': 'Subskrypcja nieaktywna',
  'set.subscriptionTrialUntil': 'Okres próbny do {date}',
  'set.subscriptionChooseHelp': 'Wybierz plan, aby rozpocząć płatność w Stripe.',
  'set.subscriptionDisconnected': 'Niepołączone',
  'set.subscriptionCurrentPlan': 'Obecny plan',
  'set.subscriptionChoosePlan': 'Wybierz {name}',
  'set.subscriptionFeature.bookkeeping': 'Księgowanie',
  'set.subscriptionFeature.invoiceEmailEhf': 'Faktura e-mailem i EHF',
  'set.subscriptionFeature.publicFiling': 'Składanie do urzędów',
  'set.subscriptionFeature.invoiceEmail': 'Faktura e-mailem',
  'set.subscriptionFeature.taxFigures': 'Dane do VAT i zeznania podatkowego',
  'set.subscriptionFeature.taxIntegration': 'Integracja ze Skatteetaten',
  'set.acc.setupTab': 'Konfiguracja',
  'set.acc.chartTab': 'Plan kont',
  'set.acc.vatPeriodAnnual': 'Rocznie',
  'set.acc.vatPeriodBimonthly': 'Co dwa miesiące',
  'set.acc.vatPeriodMonthly': 'Miesięcznie',
  'set.acc.vatPeriodQuarterly': 'Kwartalnie',
  'set.acc.vatPeriod.monthly': 'Miesięcznie',
  'set.acc.vatPeriod.bimonthly': 'Co dwa miesiące',
  'set.acc.vatPeriod.quarterly': 'Kwartalnie',
  'set.acc.vatPeriod.semiannual': 'Półrocznie',
  'set.acc.vatPeriod.annual': 'Rocznie',
  'set.acc.vatPeriodEffectiveYear': 'Obowiązuje od roku',
  'set.acc.vatPeriodEffectiveYearHelp': 'Podaj rok wskazany w decyzji Skatteetaten. Zmiana obowiązuje od 1 stycznia tego roku. Zamknięty rok trzeba ponownie otworzyć, a złożone MVA-meldinger najpierw otworzyć lub wycofać.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Podaj prawidłowy rok w formacie czterocyfrowym.',
  'set.acc.vatPeriodHistory': 'Historia okresu VAT',
  'set.acc.vatPeriodConfirmTitle': 'Czy na pewno chcesz zmienić okres VAT?',
  'set.acc.vatPeriodConfirmText': 'Zmiana obowiązuje od 1 stycznia {year}. Sprawdź, czy rok zgadza się z decyzją Skatteetaten. Wcześniejsze lata pozostają bez zmian. Zamknięty rok trzeba ponownie otworzyć, a złożone MVA-meldinger najpierw otworzyć lub wycofać.',
  'set.acc.vatPeriodConfirm': 'Potwierdź zmianę',
  'set.acc.notVatRegisteredNotice': 'Gdy firma nie jest zarejestrowana jako podatnik VAT, nowe faktury mają stawkę 0 % VAT. Zakupy nadal można rejestrować z VAT z dokumentu, ale bez prawa do odliczenia.',
  'set.acc.midYearText': 'Użyj tej opcji, jeśli przechodzisz do Plumme w trakcie roku i chcesz, aby raporty kontynuowały dane z poprzedniego systemu.',
  'set.acc.openingSaved': 'Dane początkowe zapisane',
  'set.acc.openingSavedFrom': 'Dane początkowe zapisane od {date}.',
  'set.acc.openingBalanceText': 'Użyj tej opcji, jeśli zaczynasz nowy rok obrotowy i chcesz wprowadzić salda otwarcia z poprzedniego roku.',
  'set.startup.linkedBalanceTitle': 'Bilans otwarcia uwzględniony',
  'set.startup.linkedBalanceHelp': 'To te same linie bilansu co w kreatorze bilansu otwarcia. Linie bankowe poprawia się w Ustawienia - Bank.',
  'set.acc.balanceBooked': 'Zaksięgowano {date} - {count} {lines}',
  'set.acc.line': 'linia',
  'set.acc.lines': 'linie',
  'set.acc.enterAccountNumber': 'Wpisz numer konta',
  'set.acc.equivalentHint': 'Określa sposób ujęcia w zamknięciu roku i zeznaniu podatkowym.',
  'set.acc.saveChart': 'Zapisz plan kont',
  'set.acc.equivalentShort': 'Odpowiada',
  'set.acc.usedInHistory': 'Użyte w historii',
  'set.acc.activate': 'Aktywuj',
  'set.acc.editAccount': 'Edytuj konto',
  'set.acc.deactivateUsed': 'Dezaktywuj używane konto',
  'set.acc.deleteUnused': 'Usuń nieużywane konto',
  'set.ib.intro': 'Tutaj wprowadzasz salda otwarcia z poprzedniego roku obrotowego. Użyj tej opcji, gdy zaczynasz nowy rok i chcesz, aby bilans w Plumme był poprawny od pierwszego dnia.',
  'set.ib.attachment': 'Załącznik',
  'set.ib.uploadDocuments': 'Prześlij dokumenty',
  'set.ib.uploading': 'Przesyłanie...',
  'set.ib.created': 'Utworzono',
  'set.ib.uploadReceipt': 'Prześlij nowy dokument',
  'set.ib.emptyHelp': 'Musisz dodać co najmniej jedną linię, zanim utworzysz bilans otwarcia. Użyj przycisku „Dodaj nową linię”, aby wprowadzić dane z poprzedniego systemu.',
  'set.ib.postHelp': 'Potwierdź, że bilans otwarcia jest poprawny i gotowy do zaksięgowania. Nadal możesz go zmienić później, dopóki okres jest otwarty.',
  'set.ib.draftFor': 'Szkic bilansu otwarcia na {date}',
  'set.ib.createdAt': 'Utworzono {date}',
  'set.ib.balanceHelp': 'Wpisz saldo każdego konta z zamkniętej księgowości. Cały bilans otwarcia musi mieć równe sumy Wn i Ma.',
  'set.ib.noteOptional': 'Uwaga (opcjonalnie)',
  'set.ib.difference': 'Różnica',
  'set.ib.saveDraft': 'Zapisz szkic',
  'set.ib.validationHelp': 'Sprawdź, czy każda linia ma konto i dodatnią kwotę tylko po jednej stronie oraz czy suma Wn równa się sumie Ma.',
  'set.ib.excludedRows': 'Konta wynikowe lub nieznane wyłączone ze zwykłego bilansu otwarcia: {count}. Sprawdź je w źródle importu.',
  'set.transitionImport.confirmSigned': 'Potwierdź kolumnę i konwencję znaku przed importem',
  'set.transitionImport.balanceColumn': 'Kolumna salda',
  'set.transitionImport.signConvention': 'Konwencja znaku',
  'set.transitionImport.positiveDebit': 'Dodatnie to Wn, ujemne to Ma',
  'set.transitionImport.positiveCredit': 'Dodatnie to Ma, ujemne to Wn',
  'set.transitionImport.signExample': 'Przykład: przy „dodatnie to Wn” −427 473,92 staje się Ma 427 473,92.',
  'set.transitionImport.confirmImport': 'Potwierdź i wyświetl podgląd',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV lub obraz. Przeciągnij lub wklej za pomocą Ctrl+V.',
  'sd.deleteAllTitle': 'Usuń wszystkie: {label}',
  'sd.deleteAllMessage': 'Usunąć wszystkie: {label} ({count})? Historyczne faktury i dokumenty zostaną zachowane, ale rejestr zostanie wyczyszczony. Tej operacji nie można cofnąć. Zalecamy najpierw wykonać eksport.',
  'sd.label.customers': 'klienci',
  'sd.label.suppliers': 'dostawcy',
  'sd.label.products': 'produkty',
  'sd.importing': 'Importowanie...',
  'sd.documentReferenceMissing': 'Dokument nie ma odniesienia do pakietu importu.',
  'sd.documentLinkFailed': 'Nie udało się pobrać linku do dokumentu.',
  'sd.documentOpenFailed': 'Nie udało się otworzyć zaimportowanego dokumentu.',
  'sd.kind.voucher': 'Dokumenty księgowe',
  'sd.kind.inbox': 'Skrzynka odbiorcza',
  'sd.kind.bankReconciliation': 'Uzgodnienia bankowe',
  'sd.kind.company': 'Dokumenty firmy',
  'sd.kind.invoice': 'Faktura',
  'sd.kind.quote': 'Oferta',
  'sd.kind.creditNote': 'Faktura korygująca',
  'sd.kind.orderConfirmation': 'Potwierdzenie zamówienia',
  'sd.kind.paymentReminder': 'Przypomnienie o płatności',
  'sd.kind.otherCount': 'Inne {count}',
  'sd.kind.allCount': 'Wszystkie {count}',
  'sd.reportCsv': 'Raport CSV',
  'sd.reportXlsx': 'Raport XLSX',
  'sd.openItems.exported': 'Wyeksportowane otwarte pozycje: {count}',
  'sd.openItems.exportFailed': 'Nie udało się wyeksportować raportu.',
  'sd.openItems.title': 'Sprawdź zaimportowane otwarte pozycje',
  'sd.openItems.count': 'otwarte pozycje',
  'sd.openItems.remainingTotal': 'suma pozostałych kwot',
  'sd.openItems.possibleDeviations': 'możliwe rozbieżności',
  'sd.openItems.search': 'Szukaj po nazwie, nr faktury, dacie lub arkuszu',
  'sd.filter.all': 'Wszystkie',
  'sd.filter.customers': 'Klienci',
  'sd.filter.suppliers': 'Dostawcy',
  'sd.openItems.checkDeviation': 'Sprawdź rozbieżności względem salda rozrachunków',
  'sd.openItems.deviation': '{label}: {party} różni się o {amount}',
  'sd.unnamed': 'Bez nazwy',
  'sd.openItems.rowMeta': '#{invoice} · data {date} · termin {due}',
  'sd.openItems.empty': 'Brak otwartych pozycji importu pasujących do filtra.',
  'sd.documents.title': 'Archiwum zaimportowanych dokumentów',
  'sd.documents.count': 'dokumenty',
  'sd.documents.types': 'typy',
  'sd.documents.packages': 'pakiety eksportu',
  'sd.documents.search': 'Szukaj po pliku, roku, nr dokumentu lub ścieżce wewnętrznej',
  'sd.documents.sortType': 'Sortuj: typ',
  'sd.documents.sortYear': 'Sortuj: rok',
  'sd.documents.sortName': 'Sortuj: nazwa pliku',
  'sd.documents.basis': 'Podstawa archiwum',
  'sd.documents.basisHelp': 'Dokumenty są zapisane jako indeks importu powiązany z oryginalnym pakietem eksportu. Nie tworzą automatycznie faktur, zakupów, dokumentów księgowych ani elementów skrzynki odbiorczej.',
  'sd.documents.fallback': 'Dokument',
  'sd.documents.unknownPath': 'Nieznana ścieżka w pakiecie eksportu',
  'sd.documents.fetching': 'Pobieranie...',
  'sd.documents.open': 'Otwórz',
  'sd.documents.empty': 'Żaden zaimportowany dokument nie pasuje do filtra.',
  'sd.ledger.title': 'Zaimportowane archiwum księgi głównej',
  'sd.ledger.linesShown': 'wiersze historii w wyświetlanym archiwum',
  'sd.ledger.debitShown': 'Wn w wyświetlanym wyborze',
  'sd.ledger.creditShown': 'Ma w wyświetlanym wyborze',
  'sd.ledger.search': 'Szukaj po dokumencie, koncie, tekście, dacie lub źródle',
  'sd.ledger.allYears': 'Wszystkie lata',
  'sd.ledger.historyOnly': 'Tylko historia',
  'sd.ledger.historyHelp': 'Wiersze tutaj to czytelne archiwum importu z poprzedniego systemu. Sumy powyżej to Wn/Ma dla wyświetlanego wyboru archiwum, a nie obroty. Wiersze nie są uwzględniane w raportach Plumme, VAT, podatku, uzgodnieniu bankowym ani w bieżącej liście dokumentów.',
  'sd.ledger.noText': 'Brak tekstu',
  'sd.ledger.linkedCount': 'Powiązane dokumenty w archiwum dokumentów: {count}',
  'sd.ledger.empty': 'Żaden zaimportowany wiersz księgi głównej nie pasuje do filtra.',
  'sd.ledger.linkedTitle': 'Powiązane dokumenty',
  'sd.ledger.archiveDocument': 'Dokument archiwalny',
  'sd.ledger.archiveDocumentHelp': 'To odniesienia do dokumentów z oryginalnego pakietu eksportu. Nie tworzą bieżących dokumentów ani elementów skrzynki odbiorczej.',
  'sd.ledger.noDocumentDetails': 'Dla tego wiersza nie zapisano szczegółów dokumentu.',
  'sd.ledger.showing': 'Wyświetlono {shown} z {total} wyników dla tego wiersza historii.',
  'sd.transition.exported': 'Wyeksportowane lata: {count}',
  'sd.transition.exportFailed': 'Nie udało się wyeksportować raportu przejściowego.',
  'sd.transition.title': 'Uzgodnienie i raport przejściowy',
  'sd.transition.years': 'lata',
  'sd.transition.openingLines': 'wiersze BO',
  'sd.transition.historyLines': 'wiersze historii',
  'sd.transition.warnings': 'ostrzeżenia kontrolne',
  'sd.transition.control': 'Kontrola przejścia',
  'sd.transition.controlHelp': 'Raport zestawia zaimportowany bilans otwarcia, rozrachunki, bank i historię księgi głównej według lat. Liczby są podstawą kontroli i nie są księgowane automatycznie.',
  'sd.transition.latestSubledger': 'Zaimportowane saldo rozrachunków bez własnego roku jest pokazywane w roku {year} jako ostatnio zaimportowane rozrachunki.',
  'sd.transition.rowSummary': 'Wiersze BO: {opening} · historyczne salda kont: {accounts} · wiersze historii: {history} · BO banku {bank}',
  'sd.transition.warningCount': 'Ostrzeżenia: {count}',
  'sd.transition.discrepancy': 'Rozbieżność {amount}',
  'sd.transition.historicalBalance': 'Saldo historyczne',
  'sd.transition.balanceSequence': 'BO / zmiana / BZ',
  'sd.transition.historicalResult': 'Wynik historyczny',
  'sd.transition.incomeCost': 'Przychody {income} · koszty {cost}',
  'sd.transition.itemsDeviation': 'Pozycje: {count} · rozbieżność {amount}',
  'sd.transition.supplierSubledger': 'Rozrachunki z dostawcami',
  'sd.transition.ledgerArchive': 'Archiwum księgi głównej',
  'sd.transition.empty': 'Brak zaimportowanych danych przejściowych do wyświetlenia.',
  'sd.vatTax.exported': 'Wyeksportowane wiersze: {count}',
  'sd.vatTax.exportFailed': 'Nie udało się wyeksportować historii VAT/podatku.',
  'sd.vatTax.title': 'VAT i podatek z historii importu',
  'sd.vatTax.periods': 'Okresy VAT',
  'sd.vatTax.netVat': 'VAT netto',
  'sd.vatTax.resultBeforeTax': 'wynik przed opodatkowaniem',
  'sd.vatTax.basis': 'Historyczna podstawa kontroli',
  'sd.vatTax.basisHelp': 'VAT jest sumowany z zaimportowanych kont 270x/271x dla każdego okresu. Kody VAT SAF-T są pokazywane jako podstawa kodów, jeśli plik eksportu je zawiera. Nie tworzy to nowych MVA-meldinger, dokumentów ani księgowań podatkowych.',
  'sd.vatTax.yearSummary': 'Okresy: {count} · wynik przed opodatkowaniem {amount}',
  'sd.vatTax.archive': 'Archiwum',
  'sd.vatTax.period': 'Okres {number} · {label}',
  'sd.vatTax.outputInput': 'Należny {output} · naliczony {input}',
  'sd.vatTax.empty': 'Brak zaimportowanej historii VAT/podatku do wyświetlenia.',
  'sd.vatTax.codes': 'Kody VAT SAF-T',
  'sd.vatTax.showing': 'Wyświetlono {shown} z {total}',
  'sd.vatTax.code': '{year}-{month} kod {code}',
  'sd.vatTax.baseVat': 'Podstawa {base} · VAT {vat} · {rate}%',
  'sd.resetMessage': 'To trwale usuwa wszystkie dane księgowe i operacyjne wybranej firmy: faktury, dokumenty, płatności, klientów, dostawców, produkty, wynagrodzenia, dane bankowe, bilans otwarcia, archiwa importu, pliki i wszystkie numeracje. Tej operacji nie można cofnąć. Najpierw wykonaj pełny eksport, jeśli coś ma zostać zachowane.',
  'sd.resetPreserved': 'Sam profil firmy, członkowie, subskrypcja i połączenia integracji zostają zachowane. Użyj „Usuń firmę”, jeśli również one mają zostać usunięte.',
  'sd.resetPhrase': 'POTWIERDŹ',
  'sd.resetTypeLabel': 'Wpisz {phrase}, aby włączyć resetowanie',
  'sd.resetTypeHint': 'Przycisk pozostaje nieaktywny, dopóki tekst nie zostanie wpisany dokładnie.',
  'sd.resetConfirm': 'Usuń i zresetuj wszystko',
  'sd.resetComplete': 'Wszystkie dane księgowe i operacyjne zostały usunięte. Firma została zresetowana.',
  'sd.resetFailed': 'Nie udało się ukończyć resetowania.',
  'sd.deleteBusinessMessage': 'Zaplanować usunięcie wybranej firmy za 30 dni? Firma, jej dane i dostęp zostaną usunięte po okresie karencji. Możesz anulować usunięcie przed upływem terminu.',
  'sd.deleteBusinessConfirm': 'Zaplanuj usunięcie',
  'sd.customersTitle': 'Import / eksport klientów',
  'sd.suppliersTitle': 'Import / eksport dostawców',
  'sd.productsTitle': 'Import / eksport produktów',
  'sd.invoicesTitle': 'Import / eksport faktur',
  'sd.vouchersTitle': 'Import / eksport dokumentów',
  'sd.supportedFormats': 'Obsługiwane formaty importu: .xlsx i .csv.',
  'sd.productsHelp': 'Importuj i eksportuj produkty z kolumnami szablonu. Obsługiwane formaty importu: .xlsx i .csv.',
  'sd.invoicesHelp': 'Eksportuj faktury jako CSV lub importuj nowe faktury za pomocą szablonu.',
  'sd.vouchersHelp': 'Eksportuj przegląd dokumentów lub wiersze księgowań. Import jest bezpiecznie analizowany jako kompletny pakiet eksportu.',
  'sd.importInvoices': 'Importuj faktury',
  'sd.buildingExport': 'Tworzenie pakietu eksportu...',
  'sd.exportAll': 'Eksportuj wszystko (.zip)',
  'sd.technicalJson': 'Techniczny JSON',
  'sd.analyzing': 'Analizowanie...',
  'sd.importOtherSystem': 'Importuj z innego systemu',
  'sd.reviewOpenItems': 'Sprawdź otwarte pozycje',
  'sd.documentArchive': 'Archiwum dokumentów',
  'sd.ledgerArchive': 'Archiwum księgi głównej',
  'sd.transitionReport': 'Raport przejściowy',
  'sd.vatTaxHistory': 'Historia VAT/podatku',
  'sd.latestAnalysis': 'Ostatnia analiza: pliki {files}, SAF-T {saft}, Excel {excel}, pliki dokumentów {vouchers}. Status: {status}.',
  'sd.analyzed': 'przeanalizowano',
  'sd.reanalyze': 'Przeanalizuj ten sam plik ponownie',
  'sd.reread': 'Wczytaj plik importu ponownie',
  'sd.rereadHelp': 'Ostatni plik importu jest zapisany, ale analiza nie została zakończona lub się nie powiodła.',
  'sd.importProposal': 'Propozycja: konta salda {accounts}, klienci {customers}, dostawcy {suppliers}, produkty {products}, otwarte faktury sprzedaży {customerInvoices}, otwarte faktury zakupu {supplierInvoices}, salda otwarcia {balances}, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} (wyświetlono {shown} z {total})',
  'sd.label.archiveDocuments': 'dokumenty archiwalne',
  'sd.label.historyLines': 'wiersze historii',
  'sd.saftTitle': 'Eksport SAF-T',
  'sd.saftHelp': 'Eksportuj SAF-T Financial XML (beta) lub importuj plan kont, kontrahentów i bilans otwarcia z SAF-T XML.',
  'sd.importSaft': 'Importuj SAF-T (MVP)',
});
